import {
  Channel,
  MediaConfigScope,
  MediaField,
  MediaFieldSemantic,
  MediaFieldType,
  MediaType,
  MediaTypeSemantic,
  SubmediaType,
  SubmediaTypeSemantic,
  ValidationType,
  View,
} from "routes/Base/Admin/GlobalMediaTypes/types"

import { http } from "./http"
import qs from "querystring"

// ** FETCH **
export const fetchMediaTypes = async (
  _key: string,
  params: {
    configScope: MediaConfigScope
    configOwnerId?: string
    rateCardEnabled?: boolean
    view?: View
  },
) => {
  const searchParams = qs.stringify(params)
  const { data } = await http
    .get(`media-types?${searchParams}`)
    .json<{ data: MediaType[] }>()
  return data
}

export const fetchMediaTypeSemantics = async (_key: string) => {
  const { data } = await http
    .get("media-types/semantics")
    .json<{ data: MediaTypeSemantic[] }>()
  return data
}

export const fetchMediaFields = async (
  _key: string,
  params: {
    configScope: MediaConfigScope
    configOwnerId?: string
    operands?: boolean
    includeCalculated?: boolean
  },
) => {
  const searchParams = qs.stringify(params)
  const { data } = await http
    .get(`media-fields?${searchParams}`)
    .json<{ data: MediaField[] }>()
  return data
}

export const fetchMediaFieldsSemantics = async (
  _key: string,
  params?: string,
) => {
  const searchParams = new URLSearchParams(params)
  const { data } = await http
    .get(`media-fields/semantics`, { searchParams })
    .json<{ data: MediaFieldSemantic[] }>()
  return data
}

export const fetchMediaFieldsTypes = async (_key: string) => {
  const { data } = await http
    .get("media-fields/types")
    .json<{ data: MediaFieldType[] }>()
  return data
}

export const fetchSubmediaTypeSemantics = async (
  _key: string,
  mediaTypeSemanticCode?: string,
) => {
  const searchParams = new URLSearchParams()
  !!mediaTypeSemanticCode &&
    searchParams.set("mediaTypeSemanticCode", mediaTypeSemanticCode)
  const { data } = await http
    .get(`submedia-types/semantics?${searchParams}`)
    .json<{ data: SubmediaTypeSemantic[] }>()
  return data
}

export const fetchMediaTypeChannels = async (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  const { data } = await http
    .get("channels", { searchParams })
    .json<{ data: Channel[] }>()
  return data
}

// ** CREATE **
export const createMediaField = async (pld: Partial<MediaField>) => {
  const json = pld
  const res = await http.post("media-fields", { json }).json()
  return res as MediaField
}

export const createMediaType = async (pld: Partial<MediaType>) => {
  const json = pld
  const res = await http.post("media-types", { json }).json()
  return res as Partial<MediaType>
}

export const createSubmediaType = async (pld: {
  id: string
  submediaTypes: Partial<SubmediaType>[]
}) => {
  const { id, ...submediaTypes } = pld
  const res = await http
    .post(`media-types/${id}/submedia-types`, { json: submediaTypes })
    .json()
  return res as Partial<SubmediaType>[]
}

// ** PATCH **
export const patchMediaType = async (
  pld: Partial<MediaType>,
): Promise<MediaType> => {
  const { id, ...data } = pld
  return http.patch(`media-types/${pld.id}`, { json: data }).json()
}

export const patchSubmediaType = async (
  pld: Partial<SubmediaType>,
): Promise<SubmediaType> => {
  const { id, ...data } = pld
  return http.patch(`submedia-types/${pld.id}`, { json: data }).json()
}

export const validateField = async (
  pld: Partial<MediaField>,
): Promise<ValidationType> => {
  const { id, ...data } = pld
  return http.post(`media-fields/validate/${pld.id}`, { json: data }).json()
}

export const patchField = async (
  pld: Partial<MediaField>,
): Promise<MediaField> => {
  const { id, ...data } = pld
  return http.patch(`media-fields/${pld.id}`, { json: data }).json()
}

// ** DELETE **
export const deleteMediaType = async (id: string) =>
  await http.delete(`media-types/${id}`)

export const deleteSubmediaType = async (id: string) =>
  await http.delete(`submedia-types/${id}`)

export const deleteField = async (id: string) =>
  await http.delete(`media-fields/${id}`)
